"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingPreview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const TrainingPreviewItem_1 = require("./TrainingPreviewItem");
const react_i18next_1 = require("react-i18next");
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const TrainingInfoBar_1 = require("./TrainingInfoBar");
const TopInfoBar = ({ onClick }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(TopInfo, { isClickable: !!onClick, children: [(0, jsx_runtime_1.jsx)("div", { children: onClick && (0, jsx_runtime_1.jsx)(typography_1.H4, { onClick: onClick, children: t("training.overview.title") }, void 0) }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("training.completed") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: onClick ? t("training.overview.rating") : t("training.aveRating") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("training.activities") }, void 0)] }, void 0)] }, void 0));
};
const TopInfo = styled_components_1.default.div `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  display: flex;
  justify-content: space-between;
  padding: 0 1.5rem;

  & > div {
    padding: ${({ theme }) => `${theme.spacings.m} 0`};
  }

  & > div:first-of-type {
    cursor: ${({ isClickable }) => (isClickable ? "pointer" : "unset")};
    flex: 1;
  }

  & > div:last-of-type {
    flex: 2;
    display: flex;
    justify-content: space-between;

    & > h4 {
      flex: 1;
      font-weight: 400;
    }

    & > h4:first-of-type {
      padding-left: ${({ theme }) => theme.spacings.m};
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    display: ${({ isClickable }) => (isClickable ? "flex" : "none")};

    & > div:last-of-type {
      display: none;
    }
  }
`;
const BottomInfoBar = ({ average, completedTrainings }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(BottomInfo, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("training.overview.average") }, void 0) }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.H4, { children: completedTrainings }, void 0) }, void 0), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "light-grey", children: (0, TrainingInfoBar_1.ratingValueChecked)(average) }, void 0) }, void 0), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.H4, {}, void 0) }, void 0)] }, void 0)] }, void 0));
};
const BottomInfo = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => `0 ${theme.spacings.xl}`};

  & > div:first-of-type {
    flex: 1;
    padding-top: ${({ theme }) => theme.spacings.xs};
  }

  & > div:last-of-type {
    flex: 2;
    display: flex;
    justify-content: space-between;
    padding: ${({ theme }) => `${theme.spacings.xs} 0 ${theme.spacings.xs} ${theme.spacings.xl}`};

    & > * {
      align-items: center;
      display: flex;
      flex: 1;
    }

    & > div:first-of-type h4 {
      color: ${({ theme }) => theme.colors.greyLighten40};
      font-weight: 400;
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:last-of-type {
      flex: 0;
      justify-content: flex-end;

      & > div {
        flex: 0;
        margin-left: 1rem;
      }

      & > div:last-of-type h4 {
        width: 1.5rem;
      }
    }
  }
`;
const TrainingPreview = ({ weekItems, average, completedTrainings, onHeaderClick }) => {
    return ((0, jsx_runtime_1.jsxs)(Content, { isClickable: !completedTrainings, children: [(0, jsx_runtime_1.jsx)(TopInfoBar, { onClick: onHeaderClick }, void 0), (0, jsx_runtime_1.jsx)("div", { children: weekItems.map((item) => ((0, jsx_runtime_1.jsx)(TrainingPreviewItem_1.TrainingPreviewItem, { ...item }, item.label))) }, void 0), completedTrainings && ((0, jsx_runtime_1.jsx)(BottomInfoBar, { completedTrainings: completedTrainings, average: average || "" }, void 0))] }, void 0));
};
exports.TrainingPreview = TrainingPreview;
const Content = styled_components_1.default.div `
  border: 1px solid ${({ theme }) => theme.colors.silverBase};

  & > div:nth-of-type(2) {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    padding: 0 1.5rem;

    & > div:first-of-type {
      padding-top: 1rem;
    }
  }

  & > div:not(:first-of-type) > div {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.silverLighten70};
  }

  & > div:last-of-type > div:last-of-type {
    border-bottom: none;
    padding-bottom: ${({ theme }) => theme.spacings.m};
  }

  & > div:nth-of-type(2) * {
    cursor: ${({ isClickable }) => (isClickable ? "cursor" : "auto")};
  }
`;
//# sourceMappingURL=TrainingPreview.js.map